//firebase.js
"use strict";

class Firebase {
  constructor() {
    this.#initializeApp();
  }

  async #initializeApp() {
    try {
      await this.#loadScript("https://www.gstatic.com/firebasejs/8.3.1/firebase-app.js");
      if (!window.firebase) {
        throw new Error("");
      }
      if (!firebase.apps.length) {
        firebase.initializeApp(FIREBASE_CONFIG_JS);
      }
      if (window.FIREBASE_USE_EMULATOR === true && window.FIREBASE_AUTH_EMULATOR_BROWSER_URL) {
        await this.#loadScript("https://www.gstatic.com/firebasejs/8.3.1/firebase-auth.js");
        firebase.auth().useEmulator(window.FIREBASE_AUTH_EMULATOR_BROWSER_URL);
      }
    } catch (error) {
      console.error("Error loading Firebase SDK:", error);
    }
  }

  async #loadScript(src) {
    return new Promise((resolve, reject) => {
      if (document.querySelector(`script[src="${src}"]`)) {
        return resolve();
      }
      const script = document.createElement("script");
      script.src = src;
      script.rel = "preconnect";
      document.body.append(script);

      script.onload = () => resolve();
      script.onerror = () => reject(new Error(`Failed to load script: ${src}`));
    });
  }

  /**
   * Ensure Firebase is initialized
   */
  async ensureInitialized() {
    if (!window.firebase) {
      await this.#initializeApp();
    } else if (!firebase.apps.length) {
      firebase.initializeApp(FIREBASE_CONFIG_JS);
    }
    return window.firebase;
  }

  initAuth() {
    return new Promise(async (resolve, reject) => {
      try {
        const auth = await this.#Auth();
        resolve(auth);
      } catch (error) {
        console.error("Error initializing Firebase Auth:", error);
        reject(error);
      }
    });
  }
  #Auth() {
    return new Promise((resolve, reject) => {
      const win = window;
      const firebaseModule = win.auth;

      if (firebaseModule && firebaseModule.auth) {
        return resolve(firebaseModule.auth());
      }

      const script = document.createElement("script");
      script.src = "https://www.gstatic.com/firebasejs/8.3.1/firebase-auth.js";
      script.rel = "preconnect";
      document.body.append(script);

      script.onload = () => {
        const loadedFirebaseModule = win.firebase;
        if (loadedFirebaseModule && loadedFirebaseModule.auth) {
          resolve(loadedFirebaseModule.auth());
        } else {
          reject("FireAuth is not available at the moment");
        }
      };
    });
  }

  async renderRecaptcha(containerId, options = { size: "invisible" }) {
    const auth = await this.#Auth();
    return new auth.RecaptchaVerifier(containerId, options);
  }

  resetRecaptcha(recaptchaVerifier) {
    if (recaptchaVerifier) {
      recaptchaVerifier.clear();
      recaptchaVerifier.render();
    }
  }
}

const $Firebase = new Firebase();
